import { LitElement, html, css } from 'lit'
import {customElement, property, query} from 'lit/decorators.js'
import $ from 'jquery'
import 'datatables.net-responsive-dt'
import './styles/iconlibrary'
import { Config, ConfigLanguage } from 'datatables.net'
import { SlDialog, SlInput, SlTextarea } from '@shoelace-style/shoelace'
import { v4 as uuid } from 'uuid'

import datatableCSS from './styles/datatables'
import datatableResponsiveCSS from './styles/datatables-responsive'

type ColumnSettings  = Record<string, any>;
type LangSettings    = Record<string, any>
type DTRowMetaData   = { row: number }

const LangSettings: Record<string, ConfigLanguage> = {
    ar: {
        decimal: ".",
        thousands: ",",
        search: "Recherche :",
        lengthMenu: "Afficher _MENU_ entrées",
        info: "Affichage de _START_ à _END_ sur _TOTAL_ entrées",
        infoEmpty: "Affichage de 0 à 0 sur 0 entrées",
        infoFiltered: "(filtré à partir de _MAX_ entrées au total)",
        loadingRecords: "Chargement...",
        zeroRecords: "Aucun enregistrement trouvé",
        emptyTable: "Aucune donnée disponible dans le tableau"	
    },
    fr: {
        decimal: ",",
        thousands: " ",
        search: "Recherche :",
        lengthMenu: "Afficher _MENU_ entrées",
        info: "Affichage de _START_ à _END_ sur _TOTAL_ entrées",
        infoEmpty: "Affichage de 0 à 0 sur 0 entrées",
        infoFiltered: "(filtré à partir de _MAX_ entrées au total)",
        loadingRecords: "Chargement...",
        zeroRecords: "Aucun enregistrement trouvé",
        emptyTable: "Aucune donnée disponible dans le tableau"	
    }
}

const toDate = (data: any, type: 'display' | 'filter' | 'sort' | 'type' | undefined, row: any) => {
	let html = ''
	try {
		let date = new Date(data)
		html = date.toLocaleString('fr-FR')
	}
	catch(e) { console.error(e) }
	finally  { return html }
}


const defaultColumns: ColumnSettings[] = [
    { title: '', data: null, width: "5rem", render: (data: any, type: string, row: any, meta: DTRowMetaData) => meta.row + 1},
    { title: 'date'     , data: 'last_updated'      , defaultContent: ''    , searchable: true, render: toDate, width: "15rem"  },
    { title: 'title'    , data: 'title'     , defaultContent: ''    , searchable: true },
    { visible: false    , data: 'content'   , defaultContent: ''    , searchable: true }
]


@customElement('vxc-knowledge-base')
export class TKnowledgeBase extends LitElement {
	private datatable: any;
	static styles = [
			datatableCSS,
			datatableResponsiveCSS, 
			css`
                :host {
                    --border-radius: 16px;
                    --border-color: red;
                    --sl-input-label-font-size-medium: .7rem;
                    --sl-input-focus-ring-color: black;
                    --sl-focus-ring-style: solid;
                    --sl-focus-ring-width: 1px;
                    --sl-input-border-width: 1px;
                    --sl-input-focus-ring: var(--sl-focus-ring-style) var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
                    --sl-input-focus-ring-offset: 0px;

                }
                .main {
                    height: 100%;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                }

                #add-kb {
                    float: right;
                    margin-bottom: 2rem;
                }

                h2 {
                    font-size: .8rem;
                    margin-bottom: -2rem;
                }

                p 
                { 
                    margin: 0 
                }
                .nowrap {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 300px;
                }
                .nowrap:hover {
                    overflow: visible;
                    white-space: normal;
                    background-color: #f9f9f9;
                    position: relative;
                    z-index: 10;
                }
                h1 {
                    font-size: 1rem;
                    z-index: 2;
                    margin: 0 0 -2rem 5rem;
                }
                table {
                    cursor: pointer;
                    table-layout: fixed;
                    xborder: 1px solid #DDD;
                    padding: 0px;
                    width: 100px;
                }
                table td {
                   vertical-align: top;
                   font-size: .8rem;
                }

                sl-dialog {
                    --width: 50vw;
                }

			` ];

    /** properties */
    @property({ type: String, attribute: 'title'    }) title:string = ' '
    @property({ type: Object, attribute: 'lang'     }) lang:string = 'en'       
    @property({ type: Object, attribute: 'columns'  }) columns:ColumnSettings[] = defaultColumns
    @property({ type: Object, attribute: 'data'     }) data:any[] = []
    @query('table') private table!: HTMLTableElement
    @query('#dialog') dialog!: SlDialog
    @query('#doc-uid') docUID!: HTMLInputElement
    @query('#doc-title') docTitle!: SlInput
    @query('#doc-content') docContent!: SlTextarea

    private createKB() {
        console.log()
        this.dialog?.show()
    }

    private editKB(doc: Record<string,any>) {
        this.docUID.value = doc.uid
        this.docTitle.value = doc.title
        this.docContent.value = doc.content
        this.dialog.show()
    }

    private saveKB() {
        if(this.docTitle.checkValidity() && this.docContent.checkValidity()) {
            let uid = this.docUID.value 
            let doc = uid ? this.data.find( d => d.uid === uid ) : {}
            doc.uid = doc.uid || uuid()
            doc.last_updated = new Date() 
            doc.title = this.docTitle.value 
            doc.content = this.docContent.value 
            doc.status = uid ? 'created' : 'updated'
            this.data = uid ? [...this.data] : [...this.data, doc]
            this.closeKB()
            this.dispatchEvent(new CustomEvent('updated', { detail: { value: this.data } }));
        }
    }

    private deleteKB() {
        let uid = this.docUID.value 
        let doc = this.data.find( d => d.uid === uid )
        if(doc)     doc.status = 'deleted'
        else console.error('doc not found')
        this.data = [...this.data]
        this.closeKB()
        this.dispatchEvent(new CustomEvent('updated', { detail: { value: this.data } }));
    }

    private closeKB() {
        this.dialog.hide()
    }

    private resetKG() {
        this.docUID.value = ''
        this.docTitle.value = ''
        this.docContent.value = ''
    } 

    firstUpdated() {
    }

	updated(changedProperties: Map<string | number | symbol, unknown>) {
		if(!this.columns.length)	return
		let config: Config = {
			columns: this.columns,
			responsive: true,
			language: LangSettings[this.lang],
			pageLength: 20,
			lengthChange: false,
			searching: true,
			rowCallback: (row: Node, item: any)=> {
				$(row).on('click', () => {
					console.log('click', item)
                    this.editKB(item)
				})
			},
            data: this.data
		}
        if(this.datatable) {
            let data = this.data.filter( doc => doc.status !== 'deleted' )
            this.datatable.clear()
            this.datatable.rows.add(data)
            this.datatable.draw()
        }
		else this.datatable = $(this.table).DataTable(config)
        console.log('rendered table', this.data)
    	super.updated(changedProperties)
  	}

	render () {
		return html`
        <div class="main">
            <h2>${this.title}</h2>
            <table class="table stripe"></table>
        </div>
        <sl-button id="add-kb" variant="neutral" @click=${this.createKB}>Add new knowledge</sl-button>
        <sl-dialog label="Knowledge Editor" id="dialog" @sl-after-hide=${this.resetKG}>
            <div class="editor-container">
                <input type="hidden" id="doc-uid" value="">
                <sl-input id="doc-title" label="title" help-text="give a title to your knowledge" required></sl-input><br/>
                <sl-textarea id="doc-content" label="content" placeholder="knowledge text" help-text="Enter your knowledge text here (use markdown if possible)" required></sl-textarea>
            </div>
            <sl-button slot="footer" variant="neutral" @click=${this.closeKB} outline>Close</sl-button>
            <sl-button slot="footer" variant="neutral" @click=${this.saveKB}>Save</sl-button>
            <sl-button slot="footer" variant="danger"  @click=${this.deleteKB} outline>Delete</sl-button>
        </sl-dialog>

		`
  }
}
declare global {
  interface HTMLElementTagNameMap {
    'vxc-knowledge-base': TKnowledgeBase
  }
}